export default {
  noData: 'Brak danych',
  delConfirmTips: 'Na pewno chcesz usunąć wybrany element?',
  delSuccess: 'Pomyślnie usunięto',
  tips: 'Wskazówki',
  add: 'Dodaj',
  edit: 'Edytuj',
  del: 'Usuń',
  editSuccess: 'Pomyślnie zmodyfikowano',
  activeAccount: 'Aktywuj konto',
  mailActiveSuccess: 'Pomyślnie aktywowano konto',
  back: 'Wróć',
  goLogin: 'Przejdź do logowania',
  email: 'Email',
  emailSendSuccess: 'Email wysłany pomyślnie',
  paySuccess: 'Płatność przeszła pomyślnie',
  action: 'Akcja',
  logoutSuccess: 'Pomyślne wylogowanie',
  plsUpload: 'Proszę przesłać',
  upload: 'Prześlij',
  file: 'Plik',
  uploadFail: 'Wystąpił błąd podczas przesyłania',
  uploadSuccess: 'Pomyślnie przesłano',
  pay: 'Zapłać',
  day: 'Dzień',
  servePrice: 'Opłata za usługę',
  skillServePrice: 'Opłata za usługę techniczną',
  unitMonth: 'Miesiąc(y)',
  num: 'Ilość',
  photo: 'Zdjęcie',
  product: 'Przedmiot',
  sizeHaveUnit: 'Rozmiar (cm)',
  weightHaveUnit: 'Waga (g)',
  fee: 'Opłata',
  free: 'Darmowe',
  submitTime: 'Data przesyłania',
  weight: 'Waga',
  cancelReason: 'Powód anulowania',
  submitPackage: 'Wyślij paczkę',
  submitSuccess: 'Pomyślnie przesłano',
  price: 'Cena',
  status: 'Status',
  noProduct: 'Brak produktów',
  backEdit: 'Wróć do edycji',
  errorHint: 'Błąd interfejsu, spróbuj ponownie',
  reload: 'Odśwież',
  reloadPageTips: 'Zmieniłeś konto. Proszę odśwież stronę aby zaktualizować informacje.',
  cancel: 'Anuluj',
  noMsg: 'Brak informacji',
  totalAmount: 'Całkowita kwota',
  see: 'Zobacz',
  confirm: 'Potwierdź',
  send: 'Wyślij',
  nowNoInfo: 'Brak informacji w tej chwili',
  genderEnum: {
    0: 'Mężczyzna',
    1: 'Kobieta',
  },
  goEmailActiveTips: 'Sprawdź swojego emaila, aby aktywować konto!',
  holder: {
    inputRemark: 'Proszę wpisać uwagi',
    inputExplainCancelReason: 'Proszę wyjaśnić powód anulowania',
    inputAddAddress: 'Proszę dodać adres do wysyłki',
    inputMsg: 'Proszę wpisać wiadomość',
  },
  acceptMsg:
    'Nasza strona przechowuje pliki cookie na swoim komputerze, aby zapewnić lepsze doświadczenie. Więcej informacji znajduje się w polityce prywatności.',
  accept: 'Zaakceptuj',
  refuse: 'Odrzuć',
  notice: 'Ogłoszenie',
  noticeMsg: 'Nowa linia logistyczna, 10% obniżka ceny',
  english: 'Angielski',
  spanish: 'Hiszpański',
  french: 'Francuski',
  chinese: 'Chiński',
  copySuccess: 'Skopiowano',
  copyError: 'Nie udało się skopiować',
  noAgainShow: 'Nie pokazuj ponownie',
  download: 'Pobierz',
  downloadSuccess: 'Pobieranie przeszło pomyślnie',
  uploadImgTips: 'Proszę przesłać pliki JPG/PNG/WEBP/JPEG',
  noCheckAboutAgree: 'Nie zaznaczono zgody na umowę',
  country: 'kraj',
  collectSuccess: 'Kolekcja pomyślna!',
  cancelCollectSuccess: 'Skutecznie anulowana subskrypcja!',
  formatError: 'Błąd formatu, na przykład: {formatStr}',
  volume: 'Objętość (cm)',
  notRequired: 'Nie wymagane',
  productSaleCount: 'Obroty',
  searchPlaceholder: 'Proszę wpisać treść wyszukiwania',
  THEME_MODE: 'Tryb motywu',
  FOLLOW_SYSTEM: 'Postępuj zgodnie z systemem',
  DAY_MODE: 'Tryb dzienny',
  NIGHT_MODE: 'Tryb nocny',
}
